export default "__VITE_ASSET__f40435b3__"